export default "__VITE_ASSET__BIAdV7ui__"